<template>
  <div :class="componentClassName">
    <div v-if="availableNumbers" class="o-phone-dial__current-number">
      <a-current-phone
        v-model="currentNumber"
        :client-name-list="availableNumbers"
        :selected-number="selectedNumber"
        @change="currentPhoneChange"
      >
        <!-- <template v-for="(item, index) in availableNumbers" :key="index">
          <option :value="item.value">{{ item.label }}</option>
        </template> -->
      </a-current-phone>
    </div>
    <div class="o-phone-dial__field">
      <a-phone-dial-field v-model="callNumber" placeholder="相手先番号入力" @keydown="handlePhoneDialFieldKeyDown" />
    </div>
    <div class="o-phone-dial__numpad">
      <m-numpad :enable-keyboard="enableKeyboard" @click="handleNumpadClick" />
    </div>
    <div class="o-phone-dial__buttons">
      <div class="o-phone-dial__buttons-call">
        <a-button
          id="phone-outgoing-call-button"
          variant="round"
          color="primary"
          icon="phone-outgoing-call"
          label="発信"
          :disabled="![0, 10, 11].includes(callNumber.length)"
          @click="handleCallClick"
        />
      </div>
      <div class="o-phone-dial__buttons-delete">
        <a-button @click="handleDeleteClick">
          <img src="@/images/backspace.svg" />
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ACurrentPhone from '@/components/atoms/current-phone';
import APhoneDialField from '@/components/atoms/phone-dial-field';
import MNumpad from '@/components/molecules/numpad';

export default {
  name: 'o-phone-dial',
  components: {
    AButton,
    ACurrentPhone,
    APhoneDialField,
    MNumpad,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    enableKeyboard: {
      type: Boolean,
      default: false,
    },
    availableNumbers: {
      type: Array,
      default: null,
    },
    selectedNumber: {
      type: String,
      default: '',
    },
    inputNumber: {
      type: String,
      default: '',
    },
  },
  emits: ['call', 'update:currentNumber'],
  data() {
    return {
      currentNumber: '',
      callNumber: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-phone-dial');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    selectedNumber(val, oldVal) {
      this.setSelectedNumber(this.selectedNumber);
    },
    inputNumber(val, oldVal) {
      this.setInputNumber(this.inputNumber);
    },
  },
  beforeMount() {
    if (this.enableKeyboard) {
      // register global keyup event
      document.addEventListener('keydown', this.handleKeyboard);
    }
  },
  beforeUnmount() {
    if (this.enableKeyboard) {
      // unregister keyup
      document.removeEventListener('keydown', this.handleKeyboard);
    }
  },
  mounted() {
    const vm = this;
    if (vm.selectedNumber) {
      this.setSelectedNumber(vm.selectedNumber);
    } else if (vm.availableNumbers && vm.currentNumber === '' && vm.availableNumbers.length > 0) {
      this.setSelectedNumber(vm.availableNumbers[0].value);
    }
    if (this.$route.query.contactID) {
      this.callNumber = this.$route.query.contactID;
    }
  },
  methods: {
    handlePhoneDialFieldKeyDown(e) {
      e.stopPropagation();
    },
    handleCallClick() {
      this.$emit('call', this.callNumber);
    },
    handleNumpadClick(value) {
      this.callNumber += value;
    },
    handleDeleteClick() {
      this.callNumber = this.callNumber.slice(0, -1);
    },
    handleKeyboard(e) {
      const keyCode = e.keyCode;
      if (keyCode === 8) {
        this.handleDeleteClick();
      }
    },
    setSelectedNumber(value) {
      this.currentNumber = value;
    },
    setInputNumber(value) {
      this.callNumber = value;
    },
    currentPhoneChange(e) {
      this.$emit('update:currentNumber', this.currentNumber);
    },
  },
};
</script>
